import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import BrandOfficesByBillingTable from './BrandsOfficesByBillingTable'
import BrandOfficesByQuantityTable from './BrandsOfficesByQuantityTable'
import SellersByBillingTable from './SellersByBillingTable'
import SellersByQuantityTable from './SellersByQuantityTable'
import { useInitProductsData } from '../hooks/useInitProductsData'
import { useInitSellersData } from '../hooks/useInitSellerData'
import ProductsDivisionHomeByDate from './ProductsDivisionHomeByDate'
import ProductsDivisionHomeTable from './ProductsDivisionHome'
import { useInitProductsByDate } from '../hooks/useInitProductByDate'
import { useInitDivisionBikesData } from '../hooks/useInitDivisionBikesData'
import { Col, Divider } from 'antd'

function DivisionBikes() {

    const params = useParams()

    const sucursales = useRef(null)
    const productos = useRef(null)
    const vendedores = useRef(null)

    const division = "bikes"

    const bikesData = useSelector(state => state.bikes.bikesData)
    const bikesSellersData = useSelector(state => state.bikes.bikesSellersData)
    const bikesProductsData = useSelector(state => state.bikes.bikesProductsData)
    const bikesProductsDataByDate = useSelector(state => state.bikes.bikesProductsDataByDate)

    const datesToFilter = useSelector(state => state.user.datesToFilter)

    useInitDivisionBikesData({ data: bikesData, fDate: datesToFilter?.fDate, eDate: datesToFilter?.eDate })
    useInitProductsByDate({ data: bikesProductsDataByDate, fDate: datesToFilter?.fDate, eDate: datesToFilter?.eDate, division, date: true })
    useInitProductsData({ data: bikesProductsData, fDate: datesToFilter?.fDate, eDate: datesToFilter?.eDate, division })
    useInitSellersData({ data: bikesSellersData, fDate: datesToFilter?.fDate, eDate: datesToFilter?.eDate, division })

    useEffect(() => {
        if (params.section === 'sucursales') {
            sucursales?.current?.scrollIntoView({ behavior: "smooth" })
        }
        if (params.section === 'productos') {
            productos?.current?.scrollIntoView({ behavior: "smooth" })
        }
        if (params.section === 'vendedores') {
            vendedores?.current?.scrollIntoView({ behavior: "smooth" })
        }


    }, [params.section])


    return (
        <>
            <Col span={24}>
                <h2 ref={sucursales} >Sucursales</h2>
                <BrandOfficesByBillingTable />
                <BrandOfficesByQuantityTable />
            </Col>
            <Divider />
            <Col span={24}>
                <h2 ref={vendedores}>Vendedores</h2>
                <SellersByBillingTable />
                <SellersByQuantityTable />
            </Col>
            <Divider />
            <Col span={24}>
                <h2 ref={productos}>Productos</h2>
                <ProductsDivisionHomeTable />
                <ProductsDivisionHomeByDate />
            </Col>
        </>
    )
}

export default DivisionBikes